@if (skeleton()) {
<lib-skeleton-loader
  [theme]="{
    'height.px': 32,
    'width.%': 100
  }"
></lib-skeleton-loader>
} @else {
<div class="flex items-center w-full gap-2">
  <div class="relative flex">
    <input
      #input
      [attr.id]="id() ? id() : null"
      [disabled]="state() === 'disabled'"
      [required]="required()"
      (keyup)="$event.key === 'Enter' && input.click()"
      type="checkbox"
      [checked]="value()"
      (change)="onNativeChange($event)"
      [ngClass]="{
        'bg-primary' : partialSelected() || value(),
      }"
      class="appearance-none checked:bg-primary disabled:opacity-50 focus:ring-0 focus:ring-offset-0 checked:bg-none bg-background hover:checked:bg-primary focus:checked:bg-primary peer select-none block w-4 h-4 rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2 cursor-pointer disabled:cursor-not-allowed border-1 border-solid border-primary outline-0"
    />

    <svg
      class="peer-checked:flex hidden absolute z-10 top-0 right-0 bottom-0 left-0 m-auto cursor-pointer peer-disabled:cursor-not-allowed"
      (click)="$event.stopPropagation(); input.click()"
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        class="fill-background"
        d="M11.0297 0.470337C11.3227 0.763306 11.3227 1.23909 11.0297 1.53206L5.02974 7.53206C4.73677 7.82502 4.26099 7.82502 3.96802 7.53206L0.968018 4.53206C0.675049 4.23909 0.675049 3.76331 0.968018 3.47034C1.26099 3.17737 1.73677 3.17737 2.02974 3.47034L4.50005 5.93831L9.97036 0.470337C10.2633 0.177368 10.7391 0.177368 11.0321 0.470337H11.0297Z"
      />
    </svg>

    <div
      (click)="$event.stopPropagation(); input.click()"
      [hidden]="!partialSelected() || value()"
      class="bg-background rounded-[2px] w-[6px] h-[6px] absolute z-10 top-0 right-0 bottom-0 left-0 m-auto cursor-pointer peer-disabled:cursor-default"
    ></div>
  </div>

  <span
    [ngClass]="{
      'opacity-50 cursor-default': state() === 'disabled',
      'cursor-pointer': state() !== 'disabled'
    }"
    class="label-semibold cursor-pointer text-foreground leading-[24px]"
    (click)="onContentClick($event, input)"
  >
    <ng-content></ng-content>
  </span>
</div>
}
